// extracted by mini-css-extract-plugin
module.exports = {"main":"Landing_main__5Xj_l"};